var map = {
	"./cs/core": [
		4965,
		965
	],
	"./da/core": [
		5806,
		806
	],
	"./de/core": [
		7649,
		649
	],
	"./en/core": [
		8229
	],
	"./es/core": [
		7733,
		733
	],
	"./fr/core": [
		3997,
		997
	],
	"./it/core": [
		3703,
		703
	],
	"./ja/core": [
		2444,
		444
	],
	"./ko/core": [
		2285,
		285
	],
	"./pl/core": [
		5499,
		499
	],
	"./ru/core": [
		7526,
		526
	],
	"./sk/core": [
		9940,
		940
	],
	"./sv/core": [
		6420,
		420
	],
	"./uz/core": [
		9801,
		801
	],
	"./zh/core": [
		9022,
		22
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;